<template>
  <div class="add-user-panel" v-if="dropDownRender">
    <div class="add-user-panel__header">
      <div class="add-user-panel__header-row">
        <div class="add-user-panel__title">{{ title }}</div>
        <IconButton
          size="super-small"
          color="secondary"
          icon="close-icon"
          @click="$emit('close')"
        />
      </div>
      <div class="add-user-panel__search">
        <div class="add-user-panel__search-icon">
          <icon name="search-icon" />
        </div>
        <input
          type="text"
          v-model="search"
          class="add-user-panel__search-input"
        />
        <IconButton
          class="add-user-panel__filter-button"
          size="super-small"
          color="secondary"
          icon="filter-icon"
          @click="active_filter = !active_filter"
        />
        <div class="filter-block" :class="{ active: active_filter }">
          <div class="filter-block__header">
            <h4 class="filter-block__title" style="color: #929baa">מסנן</h4>
            <button class="filter-block__clear-button" @click="clearFilter">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.3158 4H13.6842V7.5H20V11H4V7.5H10.3158V4Z"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M5 20H19V11H5V20Z"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.5 20V16"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M12 20V16"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M15.5 20V16"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M6.94727 20H17.0525"
                  stroke="#929BAA"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              נקה הכל
            </button>
          </div>
          <div class="filter-block__body" @click.stop>
            <div class="form__field mb-2">
              <div class="form__field" v-if="switcher === 1">
                <div class="form__field-label">קבוצה</div>
                <CustomThreeSelect
                  v-model="filter.student_group_id"
                  :options="filter_groups"
                  :multiple="false"
                  :class="'form__field-select '"
                />
              </div>
              <div class="form__field" v-if="switcher === 1">
                <div class="form__field-label">כיתה</div>
                <CustomThreeSelect
                  v-model="filter.student_class_id"
                  :options="filter_classes"
                  :multiple="false"
                  :class="'form__field-select '"
                />
              </div>
              <div class="form__field" v-if="switcher === 2">
                <div class="form__field-label">כיתה</div>
                <CustomThreeSelect
                  v-model="filter.department_id"
                  :options="departments"
                  :multiple="false"
                  :class="'form__field-select '"
                />
              </div>
              <div class="form__field" v-if="switcher === 2">
                <div class="form__field-label">כיתה</div>
                <CustomThreeSelect
                  v-model="filter.position_id"
                  :disabled="!filter.department_id"
                  :options="positions"
                  :multiple="false"
                  :class="'form__field-select '"
                />
              </div>
              <!-- <div class="form__field">
                <div class="form__field-label">רשויות</div>
                <CustomThreeSelect
                  v-model="filter.districtAdministrationIds"
                  :options="administration_select"
                  :multiple="true"
                  :class="'form__field-select '"
                />
              </div>
              <div class="form__field">
                <div class="form__field-label">מסגרות</div>
                <CustomThreeSelect
                  v-model="filter.institutionIds"
                  :options="institutions"
                  :multiple="true"
                  :class="'form__field-select '"
                />
              </div> -->
              <div class="form__row">
                <button
                  class="form__field-btn btn btn--blue"
                  @click="filtering"
                >
                  חפש
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sub-group-add-student-modal__fields">
        <div class="sub-group-add-student-modal__field">
          <input
            type="radio"
            :value="1"
            name="group-6"
            v-model="switcher"
            class="sub-group-add-student-modal__field-input"
            checked
          />
          <div class="sub-group-add-student-modal__field-label">תלמידים</div>
        </div>
        <div class="sub-group-add-student-modal__field">
          <input
            type="radio"
            :value="2"
            name="group-6"
            v-model="switcher"
            class="sub-group-add-student-modal__field-input"
          />
          <div class="sub-group-add-student-modal__field-label">עובדים</div>
        </div>
      </div>
    </div>
    <div class="add-user-panel__body" v-if="switcher === 1">
      <div class="add-user-panel__group-header">
        <CheckboxNew
          :check="isGroupSelected(studentList)"
          @checkedElem="selectGroup(studentList)"
        />
        <span class="text-check">({{ this.members_id.length }} נבחרו)</span>
      </div>
      <div class="add-user-panel__group-body">
        <div class="add-user-panel__group-list">
          <div
            class="add-user-panel__group-item"
            v-for="student in studentList"
            :key="student.id"
          >
            <CheckboxNew
              :check="isSelected(student)"
              @checkedElem="selectUser(student)"
            />
            <div class="add-user-panel__group-item-avatar">
              <img :src="student.image_path" alt="" v-avatar-placeholder />
            </div>
            <div class="add-user-panel__group-item-name">
              {{ student.name + ' ' + student.last_name }}
            </div>
          </div>
          <PaginationButton
            v-if="pageList < last_page"
            :countUsers="totalStudents"
            :view-count="viewCount"
            @clickPagination="clickPagination"
          ></PaginationButton>
        </div>
      </div>
    </div>
    <div class="add-user-panel__body" v-if="switcher === 2">
      <div class="add-user-panel__group-header">
        <CheckboxNew
          :check="isGroupSelected(workerList)"
          @checkedElem="selectGroup(workerList)"
        />
        <span class="text-check">({{ this.members_id.length }} נבחרו)</span>
      </div>
      <div class="add-user-panel__group-body">
        <div class="add-user-panel__group-list">
          <div
            class="add-user-panel__group-item"
            v-for="student in workerList"
            :key="student.id"
          >
            <CheckboxNew
              :check="isSelected(student)"
              @checkedElem="selectUser(student)"
            />
            <div class="add-user-panel__group-item-avatar">
              <div
                class="user-status"
                :class="{ online: student.worker_status_id == 1 }"
              ></div>
              <img :src="student.image_path" alt="" v-avatar-placeholder />
            </div>
            <div class="add-user-panel__group-item-name">
              {{ student.name + ' ' + student.last_name }}
            </div>
          </div>
          <PaginationButton
            v-if="pageList < last_page"
            :countUsers="totalStudents"
            :view-count="viewCount"
            @clickPagination="clickPagination"
          ></PaginationButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckboxNew from '@/Components/UI/Form/CheckBoxModal.vue';
import IconButton from '@/Components/UI/Buttons/IconButton.vue';
import checkBoxModal from '@/mixins/chekBoxModal.js';
import axios from 'axios';
import { mapState } from 'vuex';
import { myPlaginDebounce } from '@/Plugins/helper';
import PaginationButton from '@/Components/UI/Buttons/PaginationButton.vue';
import CustomThreeSelect from '@/Components/UI/Form/CustomThreeSelect.vue';

export default {
  components: { IconButton, CheckboxNew, PaginationButton, CustomThreeSelect },
  mixins: [checkBoxModal],
  props: {
    title: {
      type: String,
      default: 'הוספת משתמשים'
    },
    dropDownRender: {
      type: Boolean
    },
    adm_inst_ids: Array,
    id_project: {
      type: [Number, String],
      default: ''
    },
    administration_select: Array,
    filter_classes: Array,
    filter_groups: Array,
    institutions: Array,
    departments: Array,
    user_type: Number
  },
  data() {
    return {
      filter: {
        districtAdministrationIds: [],
        institutionIds: [],
        student_group_id: null,
        student_class_id: null,
        department_id: null,
        position_id: null
      },
      positions: [],
      // administration_select: [],
      // filter_classes: [],
      // filter_groups: [],
      // institutions: [],
      switcher: 2,
      pageList: 1,
      totalStudents: 0,
      viewCount: 0,
      last_page: 1,
      category: 'student-list',
      checkedAll: false,
      active_filter: false,
      categories: [],
      studentList: [],
      workerList: [],
      statusOnline: '',
      users: [],
      search: '',
      params_user: {
        id: 'student-list',
        slug: 'student-list',
        title: 'תלמידים',
        search: ' '
      }
    };
  },

  computed: {
    ...mapState({
      selectedCampus: s => s.settings.selectedCampus
    })
  },
  watch: {
    adm_ist_ids(val) {
      console.log(val, 'val');
    },
    'filter.department_id'(newValue, oldValue) {
      if (newValue) {
        this.getPositions();
      }
      // Здесь можно выполнить какие-то действия при изменении department_id
      // console.log('department_id изменился с', oldValue, 'на', newValue);
    },
    id_project(val) {
      if (val) {
        this.getStudentsSearch();
        this.getWorkersSearch();
      }
    },
    search: myPlaginDebounce(function (newVal) {
      this.pageList = 1;
      this.getUsersSearch();
    }, 1300),
    switcher(val) {
      if (val === 1) {
        this.workerList = [];
      }
      if (val === 2) {
        this.studentList = [];
      }
      this.last_page = 1;
      this.viewCount = 0;
      this.totalStudents = 0;
      this.pageList = 1;
      this.getUsers();
    }
  },
  mounted() {
    this.getUsers();
    // if (this.dropDownRender) {
    //   this.getCategories();
    //   this.getUsers(this.params_user);
    // }
  },
  methods: {
    getPositions() {
      axios
        .get('/api/departments/' + this.filter.department_id + '/positions')
        .then(res => {
          const array = res.data.data.map(el => {
            return { ...el, label: el.name };
          });
          this.positions = array;
        });
    },
    clearFilter() {
      this.filter = {
        districtAdministrationIds: [],
        institutionIds: [],
        student_group_id: null,
        student_class_id: null,
        department_id: null,
        position_id: null
      };
      this.filtering();
    },
    filtering() {
      this.pageList = 1;
      if (this.switcher === 1) {
        this.getStudentsSearch();
      }
      if (this.switcher === 2) {
        this.getWorkersSearch();
      }
    },
    clickPagination() {
      if (this.pageList < this.last_page) {
        this.pageList += 1;
        this.getUsers();
      }
    },
    viewUsers(user) {
      if (user && user.view === true) {
        this.$set(user, 'view', false);
      } else {
        this.$set(user, 'view', true);
      }
    },
    selectCategory(id, title, slug) {
      this.params_user = {
        id,
        title,
        slug
      };
      this.getUsers(this.params_user);
    },
    async getStudents() {
      console.log(this.adm_inst_ids, 'adm_inst_ids');
      try {
        const respons = await axios.get(
          '/api/main-info/multi-users-select/student-list',
          {
            params: {
              campus_id: this.selectedCampus.id,
              page: this.pageList,
              user_type: this.user_type ? this.user_type : '',
              search: this.search,
              student_class_id: this.filter.student_class_id,
              student_group_id: this.filter.student_group_id,
              districtAdministrationIds: this.filter.districtAdministrationIds,
              project_id: this.id_project ? this.id_project : '',
              adm_ist_ids: this.adm_inst_ids
            }
          }
        );
        if (respons) {
          this.studentList = [...this.studentList, ...respons.data.data];
          this.last_page = respons.data.meta.last_page;
          this.totalStudents = respons.data.meta.total;
          this.viewCount = respons.data.meta.to;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getWorkers() {
      console.log(this.adm_inst_ids, 'adm_inst_ids');
      try {
        const respons = await axios.get(
          '/api/main-info/multi-users-select/worker-list',
          {
            params: {
              campus_id: this.selectedCampus.id,
              page: 1,
              search: this.search,
              user_type: this.user_type ? this.user_type : '',
              districtAdministrationIds: this.filter.districtAdministrationIds,
              position_id: this.filter.position_id,
              department_id: this.filter.department_id,
              project_id: this.id_project ? this.id_project : '',
              adm_inst_ids: this.adm_inst_ids
            }
          }
        );
        if (respons) {
          this.workerList = [...this.workerList, ...respons.data.data];
          this.last_page = respons.data.meta.last_page;
          this.totalStudents = respons.data.meta.total;
          this.viewCount = respons.data.meta.to;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getStudentsSearch() {
      console.log(this.adm_inst_ids, 'adm_inst_ids');
      try {
        const respons = await axios.get(
          '/api/main-info/multi-users-select/student-list',
          {
            params: {
              campus_id: this.selectedCampus.id,
              page: this.pageList,
              search: this.search,
              user_type: this.user_type ? this.user_type : '',
              student_class_id: this.filter.student_class_id,
              student_group_id: this.filter.student_group_id,
              project_id: this.id_project ? this.id_project : '',
              districtAdministrationIds: this.filter.districtAdministrationIds,
              adm_inst_ids: this.adm_inst_ids
            }
          }
        );
        if (respons) {
          this.studentList = respons.data.data;
          this.last_page = respons.data.meta.last_page;
          this.totalStudents = respons.data.meta.total;
          this.viewCount = respons.data.meta.to;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getWorkersSearch() {
      console.log(this.adm_inst_ids, 'adm_inst_ids');
      try {
        const respons = await axios.get(
          '/api/main-info/multi-users-select/worker-list',
          {
            params: {
              campus_id: this.selectedCampus.id,
              page: 1,
              search: this.search,
              user_type: this.user_type ? this.user_type : '',
              institutionIds: this.filter.institutionIds,
              districtAdministrationIds: this.filter.districtAdministrationIds,
              position_id: this.filter.position_id,
              project_id: this.id_project ? this.id_project : '',
              department_id: this.filter.department_id,
              adm_inst_ids: this.adm_inst_ids
            }
          }
        );
        if (respons) {
          this.workerList = respons.data.data;
          this.last_page = respons.data.meta.last_page;
          this.totalStudents = respons.data.meta.total;
          this.viewCount = respons.data.meta.to;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getUsers(obj) {
      if (this.switcher === 1) {
        this.getStudents();
      }
      if (this.switcher === 2) {
        this.getWorkers();
      }
    },
    getUsersSearch() {
      if (this.switcher === 1) {
        this.getStudentsSearch();
      }
      if (this.switcher === 2) {
        this.getWorkersSearch();
      }
    }
    // async getCategories() {
    //   try {
    //     const respons = await axios.get('/api/main-info/get-users-categories', {
    //       params: {
    //         campus_id: this.selectedCampus.id
    //       }
    //     });
    //     this.categories = respons.data.data.map(el => {
    //       return { ...el, text: el.title };
    //     });
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
.online {
  background: var(--green-tints-green, #29cc44) !important;
}

.user-status {
  position: absolute;
  top: -2px;
  right: 0px;
  width: 12px;
  height: 12px;
  z-index: 1;
  border-radius: 50%;
  border-radius: 12px;
  border: 2px solid var(--background-white, #fff);
  background: #8e9ebb;
}

.form__field-btn {
  width: 100%;
}

.text-check {
  font-size: 14px;
  line-height: 24px;
  text-align: right;
  color: #7fbfff;
}

.sub-group-add-student-modal {
  &:not(:last-child) {
    margin-bottom: 32px;
  }

  &__title {
    color: #38455d;
    text-align: right;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    /* 125% */
    margin-bottom: 16px;
  }

  &__label {
    color: #38455d;
    text-align: right;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    /* 142.857% */
    margin-bottom: 4px;
  }

  &__row {
    &:not(:last-child) {
      margin-bottom: 16px;
    }
  }

  &__fields {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding: 4px;
    border-radius: 8px;
    border: 1px solid #e3e7ee;
    margin-bottom: 8px;
  }

  &__field {
    position: relative;
    cursor: pointer;
  }

  &__field-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 1;

    &:checked + .sub-group-add-student-modal__field-label {
      background-color: #eef7ff;
      color: #409fff;
    }
  }

  &__field-label {
    color: #38455d;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    transition: 0.3s;
    border-radius: 4px;
    height: 40px;
  }
}

.filter-block {
  position: absolute;
  box-shadow: 0px 2px 4px 0px rgba(56, 69, 93, 0.04),
    0px 4px 12px -2px rgba(56, 69, 93, 0.12);
  top: 58px;
  left: 0;
  width: 100%;
  min-height: 262px;
  background-color: #fff;
  padding: 12px 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 3;
  opacity: 0;
  transition: 0.3s;
  pointer-events: none;

  &.active {
    opacity: 1;
    pointer-events: all;
  }

  &__close-button {
    display: flex;
    width: 24px;
    height: 24px;
    border: none;
    background-color: transparent;
    margin-bottom: 8px;
    cursor: pointer;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  &__clear-button {
    display: flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #929baa;
    border: none;
    background-color: transparent;
    padding: 8px 4px;
  }

  &__body {
    margin-bottom: auto;
  }
}

.add-user-panel {
  z-index: 122;
  position: absolute;
  top: 0;
  left: 692px;
  width: 300px;
  height: 100%;
  border-right: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
  background: var(--background-white, #fff);
  box-shadow: 0px 4px 12px -4px rgba(56, 69, 93, 0.04),
    0px 8px 20px -4px rgba(56, 69, 93, 0.08);

  &__group-list {
    max-height: 100%;
    overflow: auto;
    padding-bottom: 32px;
  }

  &__header {
    width: 100%;
    padding: 16px;
    background: var(--background-white, #fff);
    z-index: 1;
  }

  &__header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__title {
    color: var(--dark-grey-tints-main-dark, #38455d);
    text-align: right;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }

  &__search {
    position: relative;
    margin-bottom: 16px;
  }

  &__search-icon {
    position: absolute;
    top: 50%;
    right: 12px;
    transform: translateY(-50%);
    stroke: var(--dark-grey-tints-main-grey, #8e9ebb);
  }

  &__search-input {
    border-radius: 8px;
    border: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
    background: var(--background-white, #fff);
    height: 40px;
    width: 100%;
    padding: 0 44px 0 44px;
    overflow: hidden;
    color: #38455d;
    font-size: 14px;
    font-family: Rubik;
    line-height: 24px;

    &::placeholder {
      color: var(--dark-grey-tints-main-grey, #8e9ebb);
    }

    &:focus {
      outline: none;
    }
  }

  &__filter-button {
    position: absolute;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
  }

  &__selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__amount {
    border-radius: 16px;
    background: var(--background-extra-grey, #f7f8fa);
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 8px;
    color: var(--dark-grey-tints-main-dark, #38455d);
    font-size: 14px;
    line-height: 24px;
    stroke: #8e9ebb;

    span {
      min-width: 24px;
      text-align: center;
    }
  }

  &__body {
    overflow-y: auto;
    height: calc(100% - 160px);
  }

  &__group-header {
    border-bottom: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
    background: var(--background-extra-grey, #f7f8fa);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--dark-grey-tints-main-dark, #38455d);
    text-align: right;
    font-size: 14px;
    line-height: 24px;
    cursor: pointer;
    position: relative;

    .toggle-button {
      position: absolute;
      transform: translateY(-50%);
      left: 16px;
    }

    .no-rotate {
      top: 50%;
    }

    .rotate {
      transform: scaleY(-1);
    }
  }

  &__group-item {
    padding: 8px 16px 8px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--dark-grey-tints-main-dark, #38455d);
    text-align: right;
    font-size: 14px;
    line-height: 24px;

    &:not(:last-child) {
      border-bottom: 1px solid var(--dark-grey-tints-light-grey, #e3e7ee);
    }
  }

  &__group-item-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    flex-shrink: 0;
    position: relative;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
    }
  }
}

@media (max-width: 1023px) {
  .add-user-panel {
    left: 486px;
  }
}

@media (max-width: 786px) {
  .add-user-panel {
    left: 0;
    width: 100%;
  }
}
</style>
